import React from 'react';

const LinkPageConfig = {
	settings: {
		layout: {
			config: {
				adminPage: false,
			},
		},
	},
	routes: [
		{
			path: '/admin/archive-link/:archiveId/:requests',
			exact: true,
			component: React.lazy(() => import('./LinkPage')),
		},
	],
};

export default LinkPageConfig;
